import classes from '../UsersSettingsTable.module.scss';

const statusStyle = status => {
  switch (status) {
    case 'Online': {
      return classes.statusGreen;
    }
    case 'Offline': {
      return classes.statusRed;
    }
    default: {
      return '';
    }
  }
};

export { statusStyle };
